import * as React from 'react'
import { createElement } from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'
import { MultiLevelMenu, MenuItemCategory } from '@react-admin/ra-navigation'
import { getResources } from 'react-admin'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { darkGray } from '../../constants/colorConstants'
import tracker from '../../utils/tracker'

const HIDDEN_MENUS = []

const useStyles = makeStyles({
  sidebarClose: {
    paddingLeft: '35px',
    width: '80px',
    height: '40px',
  },
  sidebarOpen: {
    paddingLeft: '53px',
    width: '204px',
  },
  root: {
    color: darkGray,
  },
})

const Menu = ({ onMenuClick, location }) => {
  const classes = useStyles()
  const open = useSelector((state) => state.admin.ui.sidebarOpen)
  const resources = useSelector(getResources)

  const selectedResourceName = location.pathname.substr(1)

  return (
    <MultiLevelMenu>
      {resources.map((resource) => {
        if (!HIDDEN_MENUS.includes(resource.name)) {
          return (
            <MenuItemCategory
              className={open ? classes.sidebarOpen : classes.sidebarClose}
              key={resource.name}
              name={resource.name}
              to={`/${resource.name}`}
              label={
                resource.options &&
                (resource.options.labelMenu ||
                  resource.options.label ||
                  resource.name)
              }
              icon={
                Array.isArray(resource.icon)
                  ? resource.name === selectedResourceName
                    ? createElement(resource.icon[1])
                    : createElement(resource.icon[0])
                  : undefined
              }
              onClick={(e) => {
                tracker.event({
                  action: `left_nav_${resource.name}_clicked`,
                  category: 'navigation',
                  label: resource.name,
                })
                if (onMenuClick !== undefined) onMenuClick(e)
              }}
            />
          )
        }
      })}
    </MultiLevelMenu>
  )
}

export default withRouter(Menu)
